import { useState, useEffect } from "react";
import { INVENTORY_IMGS, LAYER_IMGS, BACKGROUND_IMGS, PP_IMGS } from "../constants/items";
import { ORB_IMG } from "../constants/league";

const CDN = "https://pub-fe12241b7bb041a784ec4049e068ea80.r2.dev";

// URLs critiques (UI visible dès le démarrage) — bloquent le splash
const CRITICAL: string[] = [
  `${CDN}/Character.png`,
  `${CDN}/CoinIcon.png`,
  `${CDN}/PointIcon%20(1).png`,
  "https://i.postimg.cc/d3sX5KSp/ticket-foot-viol-(1).png",
  // Boîtes de packs
  "https://i.postimg.cc/vBT0vn4f/Chat-GPT-Image-Jun-16-2026-06-12-04-PM.png",
  "https://i.postimg.cc/LhKvR0NY/Chat-GPT-Image-Jun-16-2026-06-14-21-PM.png",
  "https://i.postimg.cc/TY1TWN2y/Chat-GPT-Image-16-juin-2026-18-18-32.png",
];

// Assets secondaires — chargés en arrière-plan après le splash
const LAZY: string[] = [
  ...new Set([
    ...Object.values(LAYER_IMGS),
    ...Object.values(INVENTORY_IMGS),
    ...Object.values(BACKGROUND_IMGS),
    ...Object.values(PP_IMGS),
    ...Object.values(ORB_IMG),
  ]),
];

// Kept at module level to prevent GC evicting images from the browser cache
const _imgCache: HTMLImageElement[] = [];

export interface PreloadState {
  ready: boolean;    // images critiques OK → ok to render
  progress: number;  // 0-1 sur les critiques
}

export function useImagePreloader(): PreloadState {
  const [loaded, setLoaded] = useState(0);
  const [ready, setReady] = useState(false);
  const total = CRITICAL.length;

  useEffect(() => {
    let done = 0;
    const criticalPromises = CRITICAL.map(
      (src) =>
        new Promise<void>((resolve) => {
          const img = new Image();
          _imgCache.push(img);
          img.onload = img.onerror = () => {
            done++;
            setLoaded(done);
            resolve();
          };
          img.src = src;
        })
    );

    Promise.all(criticalPromises).then(() => {
      setReady(true);
      LAZY.forEach((src) => {
        const img = new Image();
        img.src = src;
        _imgCache.push(img);
      });
    });
  }, []);

  return { ready, progress: total > 0 ? loaded / total : 1 };
}
